export enum BillingCycleStatus {
  Payable = 'payable',
  Paid = 'paid',
  Overdue = 'overdue',
  NoCharge = 'no-charge',
  Open = 'open'
}
